module.exports = __webpack_public_path__ + "img/orange_amazake.40ddb97b.jpg";